import { render, staticRenderFns } from "./UsersDropdown.vue?vue&type=template&id=420c8fae&"
import script from "./UsersDropdown.vue?vue&type=script&lang=js&"
export * from "./UsersDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports